<template>
<div class="chapter">
<div class="inner_page">
<p class="part-num" id="P1">PART I</p>
<p class="part-title">O PIONEERS</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Part1.vue?e0e21140